module.exports = __webpack_public_path__ + "static/HealthDevice-ff9d38b106832c8d8021929cc60d6c70.png";